







































import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import useBreakpoint from '@shared/composables/useBreakpoint';
import useMyLocation from '@shared/composables/useMyLocation';
import useMyStore from '@shared/composables/useMyStore';
import { distanceFromStoreKm } from '@shared/helpers/distanceFromStoreKm';
import { StoreDetails } from '@shared/types/stores';
import { UCIcon } from '@shared/ui';

import ExpanderBox from '~/components/ExpanderBox/ExpanderBox.vue';
import ButtonPrimary from '~/components/Stores/ButtonPrimary.vue';
import OpeningHours from '~/components/Stores/OpeningHours.vue';
import StoreContactInfo from '~/components/Stores/StoreContactInfo.vue';

export default defineComponent({
  name: 'StoreCard',
  components: { ButtonPrimary, StoreContactInfo, ExpanderBox, OpeningHours, UCIcon },
  props: {
    store: {
      type: Object as PropType<StoreDetails>,
      default: () => ({}),
    },
    noBackground: {
      type: Boolean,
      default: false,
    },
    alwaysOpen: {
      type: Boolean,
      default: false,
    },
    hideSelectedState: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { myLocation } = useMyLocation();
    const { myStore, saveMyStore } = useMyStore();
    const { breakpoint } = useBreakpoint();

    const setStore = () => saveMyStore(props.store);
    const isSelectedStore = computed(() => myStore.value?.placeId === props.store.placeId);
    const distanceFromMe = computed(() => {
      if (!myLocation.value?.lat || !myLocation.value?.lng) return null;
      return distanceFromStoreKm(myLocation.value, props.store).toFixed(1);
    });

    const storeLink = computed(
      () => `/stores/${props.store.placeId}/${props.store.name?.toLowerCase().replace(/ /g, '-')}`,
    );

    const hideExpanderOption = computed(() => props.store.openingHours.length === 0);

    return {
      breakpoint,
      storeLink,
      distanceFromMe,
      isSelectedStore,
      setStore,
      hideExpanderOption,
    };
  },
});
